import { formatDate, FormStyle, getLocaleMonthNames, TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateFormatConstants, LanguageConstants } from '../shared-components/constant';

@Injectable({
  providedIn: 'root',
})
export class LanguageHelperService {
  cleanNumber(numberValue: string, langCode: string) {
    if (numberValue !== undefined && numberValue !== null) {
      const isNegativeNumber = numberValue.toString().indexOf('(') === 0;
      // Removes all the occurences of blank space(s).
      let transformedDbNumber = numberValue.toString().split(' ').join('');
      switch (langCode) {
        case LanguageConstants.US_ENG_LOCALE:
        case LanguageConstants.UK_ENG_LOCALE:
        case LanguageConstants.JAPANESE_LOCALE:
        case LanguageConstants.CHINESE_LOCALE:
          transformedDbNumber = this.convertNumberFromLocaleToDbFormat(transformedDbNumber.split('.'));
          break;
        case LanguageConstants.GERMAN_LOCALE:
        case LanguageConstants.FRENCH_LOCALE:
        case LanguageConstants.ITALIAN_LOCALE:
        case LanguageConstants.SPANISH_LOCALE:
        case LanguageConstants.PORTUGAL_LOCALE:
          // If there is comma then only transformation will happen.
          if (transformedDbNumber.indexOf(',') > -1) {
            transformedDbNumber = this.convertNumberFromLocaleToDbFormat(transformedDbNumber.split(','));
          }
          break;
        default:
          break;
      }
      return isNegativeNumber && transformedDbNumber ? `-${transformedDbNumber}​​​` : transformedDbNumber;
    }
    return numberValue;
  }

  convertNumberFromLocaleToDbFormat(numArr: string[]): string {
    const noOfSections = numArr.length;
    let transformedDbNumber = '';
    let secHalf = numArr.pop();
    secHalf = secHalf.replace(/[^0-9]/g, '');

    // Removes all non-numeric chars.
    let firstHalf = numArr.join('').replace(/[^0-9]/g, '');
    firstHalf = firstHalf.replace(/[^0-9]/g, '');
    firstHalf = !firstHalf ? '0' : firstHalf;

    if (noOfSections === 1) {
      transformedDbNumber = secHalf;
    } else {
      if (firstHalf && secHalf) {
        transformedDbNumber = `${firstHalf}.${secHalf}`;
      } else {
        transformedDbNumber = '';
      }
    }
    return transformedDbNumber;
  }
 
  public convertMonthToLocale(langCode: string, month: string, isLongFormat: boolean = false): string{
    let translatedMonth = month; 

    if(month){
      const enMonthIndex = getLocaleMonthNames(LanguageConstants.US_ENG_LOCALE, 
        FormStyle.Format, isLongFormat ? TranslationWidth.Wide : TranslationWidth.Abbreviated).indexOf(month);
      
      if(enMonthIndex > -1) {
        translatedMonth = getLocaleMonthNames(langCode, 
          FormStyle.Format, 
          isLongFormat ? TranslationWidth.Wide : TranslationWidth.Abbreviated)[enMonthIndex]
          .substring(0, 3);

          translatedMonth = translatedMonth[0].toUpperCase() + translatedMonth.slice(1);
      }
    }
    return translatedMonth;
  }

  public convertDateToLocale(langCode: string, date: string, dateFormat: string): string{
    let translatedDate = date? formatDate(date, dateFormat, langCode).replace('.','') : date;
    if(dateFormat === DateFormatConstants.MONTHYEAR){
      translatedDate = translatedDate[0].toUpperCase() + translatedDate.slice(1);
    }
    else if(dateFormat === DateFormatConstants.DEFAULT_FORMAT || dateFormat === DateFormatConstants.DEFAULT_FORMAT2){
      translatedDate = translatedDate.slice(0,3) + translatedDate[3].toUpperCase() + translatedDate.slice(4);
    }
    return translatedDate
  }
}
